<template>
  <div class="drag_min" v-show="imageCount > 1">
    <div class="loop_play" @click="onLookPlay">
      <img src="../../assets/播放.svg" v-show="!isLoopPlay" />
      <img src="../../assets/暂停.svg" v-show="isLoopPlay" />
    </div>
    <div class="home_page" @click="preImage">
      <img src="../../assets/箭头_下一页.svg" />
    </div>
    <div class="drag_article">
      <van-slider
        v-model="slideIndex"
        :min="1"
        :step="1"
        :max="imageCount"
        button-size="15px"
        :bar-height="4"
        inactive-color="gray"
        @input="onSliderChange"
      >
      </van-slider>
    </div>
    <div class="end_page" @click="nextImage">
      <img src="../../assets/箭头_下一页.svg" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoopPlay',
  props: {
    imageCount: {
      type: Number,
      default: 0,
    },
    currentDicomIndex: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      isLoopPlay: false,
      slideIndex: 1,
      currentDicomIndexs: this.currentDicomIndex,
      timeoutBox: null, // 循环定时器
    }
  },

  watch: {
    currentDicomIndex() {
      this.currentDicomIndexs = this.currentDicomIndex //监听父组件的数据，同步更新子组件数据
    },
  },
  methods: {
    onLookPlay(off) {
      if (off === 1) {
        this.isLoopPlay = false
      } else {
        this.isLoopPlay = !this.isLoopPlay
      }
      // this.$emit('onLookPlay', this.isLoopPlay)
      // 循环播放图像
      if (this.isLoopPlay) {
        this.startTimeoutTwo()
      } else {
        if (this.timeoutBox) this.stopTimeout()
      }
    },
    preImage() {
      if (this.slideIndex > 1) {
        this.slideIndex--
        this.currentDicomIndexs--
        this.$emit('update:currentDicomIndex', this.currentDicomIndexs)
      } else {
        return
      }
      this.$emit('loadCurrnetDicom', this.currentDicomIndexs)
    },

    nextImage() {
      if (this.currentDicomIndexs < this.imageCount - 1) {
        this.slideIndex++
        this.currentDicomIndexs++
        this.$emit('update:currentDicomIndex', this.currentDicomIndexs)
      } else {
        this.slideIndex = this.imageCount
        return
      }
      this.$emit('loadCurrnetDicom', this.currentDicomIndexs)
    },
    onSliderChange(key) {
      this.slideIndex = key
      this.currentDicomIndexs = key - 1
      this.$emit('update:currentDicomIndex', this.currentDicomIndexs)
      this.$emit('loadCurrnetDicom', key - 1)
    },
    //设置循环播放的timeout定时器
    startTimeoutTwo() {
      clearTimeout(this.timeoutBox) //初始化timeout定时器，防止定时器重叠
      this.timeoutBox = setTimeout(() => {
        if (this.currentDicomIndex === this.imageCount - 1) {
          this.slideIndex = 1
          this.currentDicomIndexs = 0
          this.$emit('update:currentDicomIndex', this.currentDicomIndexs)
          setTimeout(() => {
            this.nextImage()
            clearTimeout(this.timeoutBox) //初始化timeout定时器，防止定时器重叠
            this.startTimeoutTwo() //循环调用函数自身，以达到循环的效果
          }, 300)
        } else {
          this.nextImage()
          this.startTimeoutTwo() //循环调用函数自身，以达到循环的效果
        }
        this.startTimeoutTwo() //循环调用函数自身，以达到循环的效果
      }, 300)
    },
    // 结束循环播放的timeout定时器
    stopTimeout() {
      clearTimeout(this.timeoutBox)
    },
  },
}
</script>

<style lang="less" scoped>
::v-deep .van-slider__button {
  background-color: rgba(60, 100, 159);
}
::v-deep .van-slider__bar{
  background-color: rgba(60, 100, 159);
}
::v-deep .van-slider {
  vertical-align: middle !important;
  line-height: 34px;
}

.drag_min {
  width: 100%;
  flex: 1;
  display: flex;
  .loop_play {
    width: 30px;
    height: 30px;
    padding: 6px 6px 5px;
  }

  .home_page {
    width: 30px;
    height: 30px;
    padding: 4px;
    img {
      transform: rotate(-180deg);
    }
  }

  .drag_article {
    height: 30px;
    position: relative;
    flex: 1;
    display: flex;
    align-items: center;
    margin: 0 10px;
  }

  .end_page {
    width: 30px;
    height: 30px;
    padding: 4px;
  }

}
</style>